import { render, staticRenderFns } from "./ShotCard.vue?vue&type=template&id=405b27c8"
import script from "./ShotCard.vue?vue&type=script&lang=js"
export * from "./ShotCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports